// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3qIgA","colMin":"styles_colMin__3BM44","colCheckbox":"styles_colCheckbox__1hSP0"};